// extracted by mini-css-extract-plugin
export var carrierNotice = "_ir-5";
export var carrierNoticePlaceholder = "_ir-6";
export var deliveryRow = "_ir-c";
export var fixedHeight = "_ir-4";
export var freightLogo = "_ir-b";
export var fullWidth = "_ir-3";
export var priceColumn = "_ir-7";
export var radioSelected = "_ir-9";
export var radioUnselected = "_ir-8";
export var selectedOption = "_ir-2";
export var selectedOptionContainer = "_ir-1";
export var selection = "_ir-0";
export var tallSkeletonText = "_ir-a";